import React, { Component } from "react";
import { render } from "react-dom";
import AppBar from "material-ui/AppBar";
import { Helmet } from "react-helmet";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import AppOverview from "./components/AppOverview";
import ScreenOverview from "./components/ScreenOverview";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "material-ui/CircularProgress";
import { APP_JSON } from "./app_src";
import State from "./components/StateOld";
import Paper from "material-ui/Paper";
import Input from "@material-ui/core/Input";
import RaisedButton from "material-ui/RaisedButton";
import stringHash from "string-hash";
import DataPage2 from "./components/DataPage2";

const styles = {
  fontFamily: "sans-serif",
  textAlign: "center",
  paddingBottom: 200
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pw: "",
      loginError: false,
      isIn: true,
      loading: false,
      page: "APP",
      pageParams: {
        screenId: "6pYMThlSdqUI6cGwuIuwSe",
        screenRef: "Shopping Cart"
      }
    };
    this.handleLoad = this.handleLoad.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.onScreenClicked = this.onScreenClicked.bind(this);
    this.goHome = this.goHome.bind(this);
  }

  componentDidMount() {
    this.handleLoad();
    this.setState({
      //page: "SCREEN",
      page: "DATA",
      pageParams: {
        screenRef: "Shopping Cart"
      }
    });
  }

  componentDidCatch(error, info) {
    console.log("ERROR " + error + " INFO: " + info);
  }

  handlePwChange(event) {
    this.setState({ loginError: false, pw: event.target.value });
  }
  handleLogin(event) {
    const hashed = stringHash(this.state.pw);
    console.log(
      "login " + this.state.pw + " -> " + hashed + "(required 2103579115)"
    );
    if (hashed !== 2103579115) this.setState({ loginError: true });
    else {
      this.handleLoad();
      this.setState({ isIn: true });
    }
  }

  handleLoad(event) {
    //event.preventDefault();
    this.setState({
      loading: true
    });
    var parsedApp = JSON.parse(APP_JSON);
    this.setState({ loading: false, app: parsedApp });

    //http://api.stackexchange.com/2.2/answers?order=desc&sort=activity&site=stackoverflow
    //const request = require('request');

    //request('https://api.nasa.gov/planetary/apod?api_key=DEMO_KEY', { json: true }, (err, res, body) => {
    //  if (err) { return console.log("ERR " + err); } else
    //  console.log(body.title);
    //});
  }

  onScreenClicked(screen) {
    console.log("clicked screen with id " + screen.id);
    this.setState({ page: "SCREEN", pageParams: { screenRef: screen.name } });
  }

  goHome() {
    this.setState({ page: "APP" });
  }

  render() {
    let globals;
    if (this.state.app && this.state.app.globals) {
      globals = this.state.app.globals.map(global => {
        return (
          <div
            style={{
              position: "fixed",
              bottom: 0,
              padding: 20,
              width: "100%",
              background: "#eeeeee",
              display: "flex",
              flexDirection: "row"
            }}
          >
            <span>Non-UI&nbsp;&nbsp;</span>
            <Paper style={{ width: "fit-content", marginRight: 10 }}>
              <State state={global} />
            </Paper>
          </div>
        );
      });
    } else {
      globals = "";
    }
    globals = "";
    let page = "";
    if (this.state.app && this.state.page === "APP") {
      page = (
        <AppOverview app={this.state.app} onGoToScreen={this.onScreenClicked} />
      );
    } else if (this.state.page === "SCREEN") {
      page = (
        <ScreenOverview
          screen={this.state.pageParams.screenRef}
          globals={this.state.app.globals}
        />
      );
    } else if (this.state.page === "DATA") {
      page = <DataPage2 />;
    }
    let error;
    if (this.state.loginError)
      error = <div style={{ color: "#ff0000" }}>Wrong Password</div>;
    else error = "";
    let login;
    if (!this.state.isIn)
      login = (
        <div style={styles}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              paddingTop: 80
            }}
          >
            <div>PASSWORD</div>

            <Input onChange={this.handlePwChange.bind(this)} />
            <br />
            {error}
            <br />
            <RaisedButton
              label="Login"
              primary={true}
              onClick={this.handleLogin}
            />
          </div>
        </div>
      );
    else login = "";
    let all;
    if (!this.state.isIn) all = "";
    else
      all = (
        <div>
          <AppBar
            title="Spec Deck"
            style={{ background: "#073642" }}
            showMenuIconButton={true}
            onLeftIconButtonClick={this.goHome}
          />
          {this.state.loading && <CircularProgress variant="indeterminate" />}
          <br />
          <div>{page}</div>
          {globals}
        </div>
      );
    return (
      <MuiThemeProvider>
        <div>
          <Helmet>
            <title>Spec Deck</title>
          </Helmet>
          {login}
          {all}
        </div>
      </MuiThemeProvider>
    );
  }
}

/*
const App = () => (
  <MuiThemeProvider>
    <div style={styles}>
      <AppBar title="Spec Deck" showMenuIconButton={false} />
      <HomeScreen />
    </div>
  </MuiThemeProvider>
);
*/
const rootElement = document.getElementById("root");
render(<App />, rootElement);



// WEBPACK FOOTER //
// ./src/index.js